import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Divider, Menu, Spin, Tabs, Typography } from 'antd';
import ReadDataTable from '../../../Common/ReadDataTable';
import ActionHeader from '../../../Common/ActionHeader';
import DeleteWarningModal from '../../../Common/DeleteWarningModal';
import '../../../Common/Form.css';
import ClassEdit from '../Classes/ClassEdit';
import {
  getClass,
  getTrialClassRegistration,
} from '../../../../services/trialClassService';
import {
  formatTrialClassSignupCSVData,
  validEmail,
} from '../../../../utilities/formatData';
import { CSVLink } from 'react-csv';
import flagMap from '../../../../data/isoCodeMap';
import TableWithSorter from '../../../Common/TableWithSorter';

const { Title } = Typography;

const ClassPage = (props) => {
  const [trialClass, setTrialClass] = useState({});
  const [formattedData, setFormattedData] = useState({});
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [offset, setOffset] = useState((current - 1) * pageSize);

  const [signUps, setSignups] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [error, setError] = useState(false);
  const [csvReport, setCsvReport] = useState({});
  const [status, setStatus] = useState({
    error: false,
    message: '',
  });

  const columns = [
    {
      title: 'ID',
      dataIndex: 'index',
      key: 'index',
      render: (value, item, index) => <span>{offset + index + 1}</span>,
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'ISO Code',
      dataIndex: 'country',
      key: 'country',
      render: (value) => <span>{flagMap[value]?.Code}</span>,
    },
    {
      title: 'Phone No',
      dataIndex: 'phone',
      key: 'phone',
      render: (text, record) => (
        <span>{`${record?.dialCode}${record?.phone}`}</span>
      ),
    },
    {
      title: 'Class Code',
      dataIndex: 'class',
      key: 'class',
      render: (value) => <span>{value?.classCode}</span>,
    },
    {
      title: 'Class Timezone',
      dataIndex: 'class',
      key: 'class',
      render: (value) => <span>{value?.timezone}</span>,
    },
    {
      title: 'Class Time',
      dataIndex: 'class',
      key: 'class',
      render: (value) => (
        <span>{new Date(value?.startDate).toLocaleDateString()}</span>
      ),
    },
    {
      title: 'Sign up time',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value) => <span>{new Date(value).toLocaleString()}</span>,
    },
  ];

  const formatData = (data) => {
    return {
      general: [
        {
          label: 'Class Code:',
          text: data.classCode ? data.classCode : '',
        },
        {
          label: 'Location:',
          text: data.location,
        },
        {
          label: 'Timezone:',
          text: data.timezone,
        },
        {
          label: 'Max student count:',
          text: data.maxVacancy,
        },
        {
          label: 'Start:',
          text: new Date(data.startDate).toLocaleString(),
        },
        {
          label: 'End:',
          text: new Date(data.endDate).toLocaleString(),
        },
        {
          label: 'Class link:',
          text: data.classLink,
        },
      ],
    };
  };

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={() => setIsEditModalVisible(true)}>Edit</Menu.Item>
      <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const getData = () => {
    setIsLoading(true);
    getClass(props.match.params.classCode)
      .then((response) => {
        if (response.data.data) {
          const trialClass = response.data.data;
          let data = formatData(trialClass);
          setTrialClass(trialClass);
          setFormattedData(data);
        } else {
          throw Error('This trial class does not exist!');
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`,
        });
        setIsLoading(false);
      });
  };

  const getEnrolment = (params, limit = pageSize, currentPage = current) => {
    getTrialClassRegistration(currentPage, limit, params)
      .then((res) => {
        if (!res.error) {
          const signUpData = res.data.data.paginatedList.filter((r) =>
            validEmail(r.email)
          );
          setSignups(signUpData);
          setCsvReport(formatTrialClassSignupCSVData(signUpData));
          setTotalCount(res.data.data.totalCount);
        } else {
          console.log(res.error);
          setError(error);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onPaginationChange = (data) => {
    getEnrolment(
      { classCode: props.match.params.classCode },
      data.pageSize,
      data.current
    );
    setCurrent(data.current);
    setPageSize(data.pageSize);
    setOffset((data.current - 1) * data.pageSize);
  };

  useEffect(() => {
    getData();
    getEnrolment({ classCode: props.match.params.classCode }, pageSize);
  }, [props.match.params.classCode]);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: '50px',
          }}
        >
          <Spin />
        </div>
      ) : status.error ? (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status.message}</Title>
        </div>
      ) : (
        <>
          <DeleteWarningModal
            isVisible={isDeleteModalVisible}
            setIsVisible={setIsDeleteModalVisible}
            deleteLink={`${process.env.REACT_APP_STATIC_SERVER_URL}/community-class/${trialClass.classCode}`}
            params={{}}
          />

          <ClassEdit
            isOpen={isEditModalVisible}
            toggle={() => setIsEditModalVisible(false)}
            trialClass={trialClass}
          />

          <ActionHeader title={trialClass.classCode} actionMenu={actionMenu} />

          {formattedData.general ? (
            <section className="grey-section">
              <Title level={5}>Details</Title>
              <ReadDataTable items={formattedData.general} />
            </section>
          ) : null}
        </>
      )}
      {totalCount > 0 ? (
        <div>
          <div>Total count: {totalCount}</div>
          {csvReport.data && csvReport.data.length > 0 ? (
            <CSVLink
              data={csvReport.data}
              headers={csvReport.headers}
              filename={csvReport.filename}
            >
              Export to CSV
            </CSVLink>
          ) : null}
          {signUps.length > 0 ? (
            <div>
              `{' '}
              <TableWithSorter
                scroll={{ x: 1000 }}
                columns={columns}
                dataSource={signUps}
                pagination={{
                  total: totalCount,
                  defaultPageSize: pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ['20', '500', '1000', '2000'],
                }}
                onChange={onPaginationChange}
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default withRouter(ClassPage);
